var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationBlueCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#DBEFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.348 15.2A6.4 6.4 0 0016.8 9.652V8h-1.6v1.652A6.4 6.4 0 009.652 15.2H8v1.6h1.652a6.4 6.4 0 005.548 5.548V24h1.6v-1.652a6.4 6.4 0 005.548-5.548H24v-1.6h-1.652zM16 20.8a4.8 4.8 0 110-9.6 4.8 4.8 0 010 9.6zm2.8-4.8a2.8 2.8 0 11-5.6 0 2.8 2.8 0 015.6 0z",
    fill: "#2355FC"
  })));
}

export default SvgLocationBlueCircle;